import React, { useState, useEffect } from "react";
import { Container, HomeFornada, TituloPagina } from "./styles";
import Swal from "sweetalert2";
import { URLBunge } from "../../Componentes/Config";
import { LogAcesso } from "../../Componentes/Funcoes";
import {
  MDBBtn,
  MDBDataTable,
  MDBTabPane,
  MDBTabContent,
  MDBNav,
  MDBNavItem,
  // MDBNavLink,
  MDBModal,
  MDBModalBody,
  MDBModalFooter,
  MDBModalHeader,
  MDBRow,
  MDBCol,
  MDBTable,
  MDBTableBody,
  MDBTableHead,
} from "mdbreact";
import { useHistory } from "react-router-dom";
import HeaderPortalVendedor from "../HeaderPortalVendedor";
import Carregando from "../../Componentes/Carregando";

import MenuPrinc from "../../Componentes/MenuPrinc";

import "mdbreact/dist/css/mdb.css";

import ReactExport from "react-data-export";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

function ConsultarCadastro() {
  const TOKEN = localStorage.getItem("c_token");
  const EMAIL_USUARIO = localStorage.getItem("c_email");
  const history = useHistory();
  const [carregando, setCarregando] = useState(true);
  const [departamento, setDepartamento] = useState(0);
  const [activeItem, setActiveItem] = useState("1");

  const [totalClientes, setTotalClientes] = useState(0);
  const [totalPontosDistribuidos, setTotalPontosDistribuidos] = useState(0);
  const [totalPontosResgatados, setTotalPontosResgatados] = useState(0);
  const [totalPontosExpirados, setTotalPontosExpirados] = useState(0);
  const [totalSaldos, setTotalSaldos] = useState(0);
  const [cnpjCadDia, setcnpjCadDia] = useState(0);
  const [cnpjCadSemana, setcnpjCadSemana] = useState(0);
  const [qtdCNPJSAtivos, setQtdCNPJSAtivos] = useState(0);
  const [qtdCNPJSInativos, setQtdCNPJSInativos] = useState(0);

  const [vendedores, setVendedores] = useState([]);
  const [vendedoresTotal, setVendedoresTotal] = useState([]);
  const [vendEscolhidos, setVendEscolhidos] = useState([]);

  const [gerentes, setGerentes] = useState([]);
  const [gerentesTotal, setGerentesTotal] = useState([]);
  const [gerenteEscolhidos, setGerenteEscolhidos] = useState([]);

  const [supervisores, setSupervisores] = useState([]);
  const [supervisoresTotal, setSupervisoresTotal] = useState([]);
  const [supEscolhidos, setSupEscolhidos] = useState([]);

  const [cnpj, setCnpj] = useState("");
  const [codigoSap, setCodigoSap] = useState("");

  const [textGer, setTextGer] = useState("");
  const [textSub, setTextSub] = useState("");
  const [textVend, setTextVend] = useState("");

  const [colunasExcel, setColunasExcel] = useState([]);
  const [clientes, setClientes] = useState([]);

  const [listaSelect, setListSelect] = useState({ sap: "" });
  const [abreModal, setAbreModal] = useState(false);

  function toggle(cliente) {
    if (cliente != null) {
      setListSelect(cliente);
    }

    setAbreModal((oldValue) => !oldValue);
  }

  function toggletab(tab) {
    if (activeItem !== tab) {
      setActiveItem(tab);
    }

    if (tab === "2") {
      limpaFiltros("tab2");
    } else {
      limpaFiltros("tab1");
    }
  }

  function limpaFiltros(tipo) {
    if (tipo === "tab1") {
      buscaVendedores();
    } else {
      setClientes([]);

      setTotalClientes(0);
      setTotalPontosDistribuidos(0);
      setTotalPontosResgatados(0);
      setTotalPontosExpirados(0);
      setTotalSaldos(0);
      setcnpjCadDia(0);
      setcnpjCadSemana(0);
      setQtdCNPJSAtivos(0);
      setQtdCNPJSInativos(0);

      setSupervisores([]);
      setSupervisoresTotal([]);
      setSupEscolhidos([]);

      setVendedores([]);
      setVendedoresTotal([]);
      setVendEscolhidos([]);

      setGerentes([]);
      setGerentesTotal([]);
      setGerenteEscolhidos([]);
    }
  }

  function escolheSupervisor(e) {
    var SupEscolhidos = supEscolhidos;

    if (e.checked) {
      SupEscolhidos.push(parseInt(e.value));
    } else {
      var index = SupEscolhidos.indexOf(parseInt(e.value));
      if (index > -1) {
        SupEscolhidos.splice(index, 1);
      }
    }

    setSupEscolhidos(SupEscolhidos);

    var vendedoresArray = [];
    var vendedoresTotalArray = [];

    vendedoresTotal.map((vend) => {
      vendedoresTotalArray.push(vend);
      if (SupEscolhidos.length <= 0) {
        vendedoresArray.push({
          id: vend.id,
          nome: vend.nome,
          idGer: vend.idPai,
        });
      } else if (
        SupEscolhidos.length > 0 &&
        SupEscolhidos.find((g) => g === vend.idPai)
      ) {
        vendedoresArray.push({
          id: vend.id,
          nome: vend.nome,
          idSup: vend.idPai,
        });
      }
    });

    setVendedores(vendedoresArray);
    setVendedoresTotal(vendedoresTotalArray);

    if (SupEscolhidos.length > 0) {
      carregaLojas();
    } else {
      limpaState();
    }
  }

  function escolheVendedor(e) {
    var VendEscolhidos = vendEscolhidos;

    if (e.checked) {
      VendEscolhidos.push(parseInt(e.value));
    } else {
      var index = VendEscolhidos.indexOf(parseInt(e.value));
      if (index > -1) {
        VendEscolhidos.splice(index, 1);
      }
    }

    setVendEscolhidos(VendEscolhidos);

    carregaLojas();
  }

  async function buscaVendedores() {
    setCarregando(true);

    const myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + TOKEN);
    myHeaders.append("Content-Type", "application/json");

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    fetch(
      `${URLBunge}/api/Vendedores/ProcuraVendedores/` + EMAIL_USUARIO,
      requestOptions
      )
      .then((response) => response.json())
      .then((result) => {
        if (result.sucesso) {
          
          const departamentoUsuario = result.departamento;
          setDepartamento(departamentoUsuario);

          // OBS: ESTUDAR MELHOR FORMA DE GUARDAR O DEPARTAMENTO PARA USAR NO HEANDER
          localStorage.setItem("@p_departamento-numero", departamentoUsuario);

          if (departamentoUsuario === 10) {
            fetch(
              `${URLBunge}/api/Usuarios/BuscarUserCAO/` + EMAIL_USUARIO,
              requestOptions
            )
              .then((response) => response.json())
              .then((result) => {
                var VendEscolhidos = [];
                VendEscolhidos.push(parseInt(result.id));

                setVendEscolhidos(VendEscolhidos);
              })
              .catch((error) => {
                console.log("error", error);
                setCarregando(false);
              });
          } else {
            if (departamentoUsuario === 11) {
              var gerentesTotal = [];
              var gerentes = [];

              if (result.gerentes != null) {
                result.gerentes.map((ger) => {
                  gerentesTotal.push(ger);
                  gerentes.push({
                    id: ger.id,
                    nome: ger.nome,
                  });
                });

                setGerentesTotal(gerentesTotal);
                setGerentes(gerentes);
              }
            }

            var supervisores = [];
            var supervisoresTotal = [];

            if (result.supervisores != null) {
              result.supervisores.map((sup) => {
                supervisoresTotal.push(sup);
                supervisores.push({
                  id: sup.id,
                  nome: sup.nome,
                });
              });

              setSupervisores(supervisores);
              setSupervisoresTotal(supervisoresTotal);
            }

            var vendedores = [];
            var vendedoresTotal = [];

            if (result.vendedores != null) {
              result.vendedores.map((ven, i) => {
                vendedoresTotal.push(ven);
                vendedores.push({
                  idPai: ven.id,
                  id: ven.id,
                  nome: ven.nome,
                });
              });
              setVendedores(vendedores);
              setVendedoresTotal(vendedoresTotal);
            }
          }
        } else {
          setSupervisores([]);
          setVendedores([]);
        }

        setCarregando(false);
      })
      .catch((error) => {
        console.log("ERRORRRRRRRRRRRR", error);
        setCarregando(false);
      });
  }

  function escolheGerente(e) {
    var GerEscolhidos = gerenteEscolhidos;

    if (e.checked) {
      GerEscolhidos.push(parseInt(e.value));
    } else {
      var index = GerEscolhidos.indexOf(parseInt(e.value));
      if (index > -1) {
        GerEscolhidos.splice(index, 1);
        // carregaLojas();
      }
    }

    setGerenteEscolhidos(GerEscolhidos);

    var supervisoresTotalArray = [];
    var supervisoresArray = [];

    supervisoresTotal.map((sup) => {
      supervisoresTotalArray.push(sup);
      if (GerEscolhidos.length <= 0) {
        supervisoresArray.push({
          id: sup.id,
          nome: sup.nome,
          idGer: sup.idPai,
        });
      } else if (
        GerEscolhidos.length > 0 &&
        GerEscolhidos.find((g) => g === sup.idPai)
      ) {
        supervisoresArray.push({
          id: sup.id,
          nome: sup.nome,
          idGer: sup.idPai,
        });
      }
    });

    setSupervisores(supervisoresArray);
    setSupervisoresTotal(supervisoresTotalArray);

    if (GerEscolhidos.length > 0) {
      carregaLojas("", supervisoresArray);
    }
  }

  function carregaLojas(tipo, supervisoresFiltrados) {
    if (tipo === "SAP" && cnpj.trim() === "" && codigoSap.trim() === "") {
      Swal.fire({
        icon: "warning",
        title: "Ops!",
        text: "Digite algum valor no campo de pesquisa.",
      });

      return;
    }

    setCarregando(true);

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + TOKEN);
    myHeaders.append("Content-Type", "application/json");

    var dadosBusca = {
      idProjeto: 2329681,
      GerentesId: [],
      SupervisoresId: [],
      VendedoresId: [],
      modalNumber: false,
    };

    if (tipo !== "SAP") {
      if (supervisoresFiltrados) {
        dadosBusca.SupervisoresId = supervisoresFiltrados.map((sup) => {
          return sup.id;
        });
      } else {
        dadosBusca.SupervisoresId = supervisores.map((sup) => {
          return sup.id;
        });
      }

      if (gerenteEscolhidos.length <= 0) {
        dadosBusca.SupervisoresId = [];
      }

      if (vendEscolhidos.length > 0) {
        dadosBusca.VendedoresId = vendEscolhidos;
      } else if (supEscolhidos.length > 0) {
        dadosBusca.SupervisoresId = supEscolhidos;
      }
    } else {
      if (cnpj != "") {
        dadosBusca.cnpj = cnpj;
      }
      if (codigoSap != "") {
        dadosBusca.codigoSap = codigoSap;
      }
    }

    var Clientes = {
      columns: [
        {
          label: "Supervisor",
          field: "supervisor",
          sort: "asc",
          width: 10,
        },
        {
          label: "Vendedor",
          field: "vendedor",
          sort: "asc",
          width: 100,
        },
        {
          label: "Cliente",
          field: "cliente",
          sort: "asc",
          width: 150,
        },
        {
          label: "Código SAP",
          field: "codigoSap",
          sort: "asc",
          width: 150,
        },
        {
          label: "Proprietário",
          field: "proprietario",
          sort: "asc",
          width: 100,
        },
        {
          label: "Status Cadastral",
          field: "cpfProp",
          sort: "asc",
          width: 100,
        },
        {
          label: "Status",
          field: "status",
          sort: "asc",
          width: 100,
        },
        {
          label: "Meta",
          field: "meta",
          sort: "asc",
          width: 80,
        },
        {
          label: "Realizado",
          field: "realizado",
          sort: "asc",
          width: 80,
        },
        {
          label: "Faixa",
          field: "faixa",
          sort: "asc",
          width: 80,
        },
        {
          label: "Farol",
          field: "farol",
          sort: "asc",
          width: 80,
        },
        {
          label: "Consultar",
          field: "consultar",
          sort: "asc",
          width: 80,
        },
        {
          label: "Detalhes",
          field: "detalhes",
          sort: "asc",
          width: 180,
        },
      ],
      rows: [],
    };

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify(dadosBusca),
      redirect: "follow",
    };

    fetch(`${URLBunge}/api/Vendedores/ProcurarTotais`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.sucesso) {
          var TotalClientes = result.cnpjLegiveis;
          var TotalPontosDistribuidos = result.pontosDistribuidos;
          var TotalPontosResgatados = result.pontosResgatados;
          var TotalPontosExpirados = result.pontosExpirados;
          var TotalSaldos = result.saldo;
          var cnpjCadDia = result.cnpjCadDia;
          var cnpjCadSemana = result.cnpjCadSemana;
          var QtdCNPJSAtivos = result.cnpjCadAtivo;
          var QtdCNPJSInativos = result.cnpjSemCad;

          setTotalClientes(TotalClientes);
          setTotalPontosDistribuidos(TotalPontosDistribuidos);
          setTotalPontosResgatados(TotalPontosResgatados);
          setTotalPontosExpirados(TotalPontosExpirados);
          setTotalSaldos(TotalSaldos);
          setcnpjCadDia(cnpjCadDia);
          setcnpjCadSemana(cnpjCadSemana);
          setQtdCNPJSAtivos(QtdCNPJSAtivos);
          setQtdCNPJSInativos(QtdCNPJSInativos);

          var colExcel = [];
          result.listaLojas.map((cliente) => {
            if (cliente.cpfProp) {
              var cpf = btoa(cliente.cpfProp);
            }

            Clientes.rows.push({
              supervisor: cliente.supervisor,
              vendedor: cliente.vendedor,
              cliente: cliente.cliente,
              codigoSap: cliente.sap,
              proprietario: cliente.proprietario,
              cpfProp: cliente.cpfProp == null ? "Sem cadastro" : "Cadastrada",
              statusCadastral: cliente.statusCadastral,
              status: cliente.status,
              meta: cliente.meta,
              realizado: cliente.realizado,
              faixa: cliente.faixa,
              farol: <div className={"bola " + cliente.farol}></div>,
              DataUltimoAcesso: cliente.dataUltimoAcesso,
              DataUltimoResgate: cliente.dataUltimoResgate,
              consultar:
                cliente.cpfProp != null ? (
                  <MDBBtn
                    className="botao-consultar"
                    onClick={() => history.push(`/ConsultarClientes/${cpf}`)}
                  >
                    Consultar
                  </MDBBtn>
                ) : (
                  ""
                ),
              detalhes: (
                <MDBBtn
                  className="botao-detalhes"
                  onClick={() => toggle(cliente)}
                >
                  Detalhes
                </MDBBtn>
              ),
            });

            colExcel.push({
              supervisor: cliente.supervisor,
              vendedor: cliente.vendedor,
              cliente: cliente.cliente,
              codigoSap: cliente.sap,
              proprietario: cliente.proprietario,
              cpfProp: cliente.cpfProp == null ? "Sem cadastro" : "Cadastrada",
              statusCadastral: cliente.statusCadastral,
              status: cliente.status,
              meta: cliente.meta,
              realizado: cliente.realizado,
              faixa: cliente.faixa,
              farol: cliente.farol,
              codLoja: cliente.codLoja,
              saldoAtual: cliente.saldoAtual,
              pontosExpirados: cliente.pontosExpirados,
              qtdResgates: cliente.qtdResgates,
              pontosResgatados: cliente.pontosResgatados,
              DataUltimoAcesso: cliente.dataUltimoAcesso,
              DataUltimoResgate: cliente.dataUltimoResgate,
              consultar:
                cliente.cpfProp != null ? (
                  <MDBBtn
                    className="botao-consultar"
                    onClick={() =>
                      history.push(`/ConsultarClientes/${cliente.cpfProp}`)
                    }
                  >
                    Consultar
                  </MDBBtn>
                ) : (
                  ""
                ),
            });
          });

          setClientes(Clientes);
          setColunasExcel(colExcel);
        } else {
          limpaState();

          if (tipo !== "SAP" && departamento === 11) {
            buscaVendedores();
          }

          if (tipo === "SAP") {
            Swal.fire({
              icon: "warning",
              title: "Atenção!",
              text: result.mensagem,
            });
          }
        }

        setCarregando(false);
      })
      .catch((error) => {
        console.log("error", error);
        Swal.fire({
          icon: "error",
          title: "Atenção!",
          text: "Erro ao carregar as informações, tente novamente.",
        });
        setCarregando(false);
      });
  }

  function verificaLogin() {
    if (TOKEN === null) {
      history.push({ pathname: "/", state: {} });
      setCarregando(false);
    } else {
      LogAcesso(TOKEN, "Academia Bunge");
    }
  }

  function limpaState() {
    setClientes([]);
    setTotalClientes(0);
    setTotalPontosDistribuidos(0);
    setTotalPontosResgatados(0);
    setTotalPontosExpirados(0);
    setTotalSaldos(0);
    setcnpjCadDia(0);
    setcnpjCadSemana(0);
    setQtdCNPJSAtivos(0);
    setQtdCNPJSInativos(0);
  }

  useEffect(() => {
    document.title = "Plataforma Vendedor | Consulta de Cadastros";

    document.body.style.overflow = "auto";

    verificaLogin();
    buscaVendedores();

    return () => {
      document.body.style.overflow = "hidden";
    };
  }, []);

  useEffect(() => {
    if (vendEscolhidos.length > 0) {
      carregaLojas();
    }
  }, [vendEscolhidos]);


  return (
    <>
      <HeaderPortalVendedor />
      <MenuPrinc />
      <Container>
        {carregando && <Carregando />}
        <HomeFornada>
          <div className="clear"></div>

          <div className="cadastros">
            <TituloPagina>Consulta de cadastros do programa</TituloPagina>

            {!carregando && (
              <MDBNav className="nav-tabs mt-5">
                <MDBNavItem>
                  {/* <MDBNavLink
                    link
                    to="#"
                    active={activeItem === "1"}
                    onClick={() => toggletab("1")}
                    role="tab"
                  >
                    {departamento == 11
                      ? "Gerentes/Supervisor/Vendedor"
                      : departamento != 10
                      ? "Supervisor/Vendedor"
                      : "Vendedor"}
                  </MDBNavLink> */}
                </MDBNavItem>

                {departamento != 10 && (
                  <MDBNavItem>
                    {/* <MDBNavLink
                      link
                      to="#"
                      active={activeItem === "2"}
                      onClick={() => toggletab("2")}
                      role="tab"
                    >
                      Cliente/CNPJ
                    </MDBNavLink> */}
                  </MDBNavItem>
                )}
              </MDBNav>
            )}

            <MDBTabContent activeItem={activeItem}>
              <MDBTabPane tabId="1" role="tabpanel" id="dash">
                {departamento === 11 && (
                  <div className="campos40">
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control"
                        id="codigo-sap"
                        value={textGer}
                        onChange={(e) => setTextGer(e.target.value)}
                        placeholder="Pesquise pelo nome"
                      />
                    </div>
                    <label>Escolha o Gerente</label>
                    <div className="selects">
                      {gerentes.map((ger, i) => {
                        if (
                          ger.nome
                            .toUpperCase()
                            .indexOf(textGer.toUpperCase()) < 0
                        ) {
                          return;
                        }
                        return (
                          <div
                            className="custom-control custom-checkbox"
                            key={i}
                          >
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              value={ger.id}
                              id={"ger" + ger.id}
                              onChange={(e) => escolheGerente(e.target)}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor={"ger" + ger.id}
                            >
                              {ger.nome}
                            </label>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}

                {departamento != 10 && (
                  <>
                    <div className="campos30">
                      {/* <label>Pesquise pelo nome</label> */}
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control"
                          id="codigo-sap"
                          value={textSub}
                          onChange={(e) => setTextSub(e.target.value)}
                          placeholder="Pesquise pelo nome"
                        />
                      </div>
                      <label>Escolha o Supervisor</label>

                      <div className="selects">
                        {supervisores.length > 0 ? (
                          supervisores.map((sup, i) => {
                            if (
                              sup.nome
                                .toUpperCase()
                                .indexOf(textSub.toUpperCase()) < 0
                            ) {
                              return;
                            }
                            return (
                              <div
                                className="custom-control custom-checkbox"
                                key={i}
                              >
                                <input
                                  type="checkbox"
                                  className="custom-control-input"
                                  value={sup.id}
                                  id={"super" + sup.id}
                                  onChange={(e) => escolheSupervisor(e.target)}
                                />
                                <label
                                  className="custom-control-label"
                                  htmlFor={"super" + sup.id}
                                >
                                  {sup.nome}
                                </label>
                              </div>
                            );
                          })
                        ) : (
                          <span>Sem informação</span>
                        )}
                      </div>
                    </div>

                    <div className="campos30">
                      {/* <label>Pesquise pelo nome</label> */}
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control"
                          id="codigo-sap"
                          value={textVend}
                          onChange={(e) => setTextVend(e.target.value)}
                          placeholder="Pesquise pelo nome"
                        />
                      </div>
                      <label>Escolha o Vendedor</label>
                      <div className="selects">
                        {vendedores.length > 0 ? (
                          vendedores.map((vend, i) => {
                            if (
                              vend.nome
                                .toUpperCase()
                                .indexOf(textVend.toUpperCase()) < 0
                            ) {
                              return;
                            }
                            return (
                              <div
                                className="custom-control custom-checkbox"
                                key={i}
                              >
                                <input
                                  type="checkbox"
                                  className="custom-control-input"
                                  value={vend.id}
                                  id={"vend" + vend.id}
                                  onChange={(e) => escolheVendedor(e.target)}
                                />
                                <label
                                  className="custom-control-label"
                                  htmlFor={"vend" + vend.id}
                                >
                                  {vend.nome}
                                </label>
                              </div>
                            );
                          })
                        ) : (
                          <span>Sem informações</span>
                        )}
                      </div>
                    </div>
                  </>
                )}

                <div id="infos">
                  <section>
                    <strong>{totalClientes.toLocaleString()}</strong>
                    <p>
                      Total de CNPJS <span></span>Elegíveis
                    </p>
                  </section>

                  <section>
                    <strong>{cnpjCadDia.toLocaleString()}</strong>
                    <p>
                      CNPJS cadastrados <span></span>no dia
                    </p>
                  </section>

                  <section>
                    <strong>{cnpjCadSemana.toLocaleString()}</strong>
                    <p>
                      CNPJS cadastrados <span></span>na semana
                    </p>
                  </section>

                  <section>
                    <strong>{qtdCNPJSAtivos.toLocaleString()}</strong>
                    <p>
                      Qtd de CNPJS <span></span>cadastrados/ativos
                    </p>
                  </section>

                  <section>
                    <strong>{qtdCNPJSInativos.toLocaleString()}</strong>
                    <p>
                      Qtd de CNPJS <span></span>sem cadastro
                    </p>
                  </section>

                  <section>
                    <strong>{totalPontosDistribuidos.toLocaleString()}</strong>
                    <p>
                      Total de pontos <span></span>distribuídos
                    </p>
                  </section>

                  <section>
                    <strong>{totalPontosResgatados.toLocaleString()}</strong>
                    <p>
                      Total de pontos<span></span> resgatados
                    </p>
                  </section>

                  <section>
                    <strong>{totalPontosExpirados.toLocaleString()}</strong>
                    <p>
                      Total de pontos<span></span> expirados
                    </p>
                  </section>

                  <section>
                    <strong>{totalSaldos.toLocaleString()}</strong>
                    <p>
                      Saldo<span></span> Total
                    </p>
                  </section>
                </div>
              </MDBTabPane>

              <MDBTabPane tabId="2" role="tabpanel" id="pesq">
                <div className="campos30">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control-filtro"
                      id="codigo-sap"
                      value={codigoSap}
                      onChange={(e) => setCodigoSap(e.target.value)}
                      placeholder="Informe o código Sap"
                    />
                  </div>
                </div>

                <div className="campos30">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control-filtro"
                      id="cnpj"
                      value={cnpj}
                      onChange={(e) => setCnpj(e.target.value)}
                      placeholder="Ou o CNPJ"
                    />
                  </div>
                </div>

                <div className="campos30">
                  <button
                    data-test="button"
                    type="button"
                    className="botao-filtro"
                    onClick={() => carregaLojas("SAP")}
                  >
                    Filtrar
                  </button>
                </div>
              </MDBTabPane>

              <div className="clear"></div>
            </MDBTabContent>

            <div id="resultado">
              <ExcelFile
                element={
                  clientes.length !== 0 && (
                    <MDBBtn
                      color="primary"
                      size="sm"
                      style={{ float: "right" }}
                    >
                      Baixar em Excel
                    </MDBBtn>
                  )
                }
              >
                <ExcelSheet data={colunasExcel} name="Employees">
                  <ExcelColumn label="Supervisor" value="supervisor" />
                  <ExcelColumn label="Vendedor" value="vendedor" />
                  <ExcelColumn label="Cliente" value="cliente" />
                  <ExcelColumn label="Código SAP" value="codigoSap" />
                  <ExcelColumn label="Proprietário" value="proprietario" />
                  <ExcelColumn
                    label="Status Cadastral"
                    value="statusCadastral"
                  />
                  <ExcelColumn label="Meta" value="meta" />
                  <ExcelColumn label="Realizado" value="realizado" />
                  <ExcelColumn label="Faixa" value="faixa" />
                  <ExcelColumn label="Farol" value="farol" />
                  <ExcelColumn label="Qtd Resgate" value="qtdResgates" />
                  <ExcelColumn
                    label="Pontos Resgatados"
                    value="pontosResgatados"
                  />
                  <ExcelColumn label="Saldo Atual" value="saldoAtual" />
                  <ExcelColumn
                    label="Pontos Expirados"
                    value="pontosExpirados"
                  />
                  <ExcelColumn label="Ultimo Acesso" value="dataUltimoAcesso" />
                  <ExcelColumn
                    label="Ultimo Resgate"
                    value="dataUltimoResgate"
                  />
                  <ExcelColumn label="Cod Loja" value="codLoja" />
                </ExcelSheet>
              </ExcelFile>

              <br />

              {clientes.length !== 0 && (
                <div className="tabresp">
                  <MDBDataTable
                    striped
                    bordered
                    hover
                    searchLabel="Pesquisar"
                    paginationLabel={["Anterior", "Próximo"]}
                    noRecordsFoundLabel="Nenhum resultado encontrado"
                    infoLabel={["Mostrando", "de", "até", "registros"]}
                    entriesLabel="Qtd por pagina"
                    data={clientes}
                  />
                </div>
              )}
            </div>
          </div>

          <MDBModal isOpen={abreModal} toggle={() => toggle()} size="lg">
            <MDBModalHeader toggle={() => toggle()}>
              <h6>
                Detalhes da loja <strong>{listaSelect.cliente}</strong>
              </h6>
            </MDBModalHeader>
            <MDBModalBody>
              <MDBRow>
                <MDBCol>
                  <MDBTable striped>
                    <MDBTableHead>
                      <tr>
                        <th>Código Loja</th>
                        <th>Saldo Atual</th>
                        <th>Pontos Expirados</th>
                        <th>Qtd Resgates</th>
                        <th>Pts Resgatados</th>
                        <th>Ultimo acesso</th>
                        <th>Ultimo Resgate</th>
                      </tr>
                    </MDBTableHead>
                    <MDBTableBody>
                      <tr>
                        <td>{listaSelect.codLoja}</td>
                        <td>{listaSelect.saldoAtual}</td>
                        <td>{listaSelect.pontosExpirados}</td>
                        <td>{listaSelect.qtdResgates}</td>
                        <td>{listaSelect.pontosResgatados}</td>
                        <td>{listaSelect.dataUltimoAcesso}</td>
                        <td>{listaSelect.dataUltimoResgate}</td>
                      </tr>
                    </MDBTableBody>
                  </MDBTable>
                </MDBCol>
              </MDBRow>
            </MDBModalBody>
            <MDBModalFooter></MDBModalFooter>
          </MDBModal>
        </HomeFornada>
      </Container>
    </>
  );
}

export default ConsultarCadastro;
